<template>
  <v-dialog :value="value" width="1500px" persistent>
    <v-card style="padding: 0px">
      <v-card-title>
        {{ isSubmitting ? "Please review the Supplier settings" : "Suppliers Setting" }}
      </v-card-title>
      <v-card-text class="black--text">
        <v-row>
          <v-col><h3>Date</h3></v-col>
          <v-col v-for="(column, index) in convertedData.columns" :key="index">
            <v-row>
              <h3>{{ column.name }}</h3>
            </v-row>
            <v-row>
              <h3 class="caption grey--text">{{ column.city }}</h3>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col></v-col>
          <v-col v-for="(column, index) in convertedData.columns" :key="index">
            <g-button label="Clear" @onclick="clearByIndex(index)" />
            <g-button label="Select All" @onclick="selectAllByIndex(index)" />
          </v-col>
        </v-row>
        <div v-for="(day, dayIndex) in convertedData.days" :key="dayIndex" class="supplier-setting-day-group">
          <v-row class="supplier-setting-day-group__header">
            <v-col align-self="center"
              ><strong>{{ day.header }}</strong></v-col
            >
            <v-col align-self="center" v-for="(include, includeIndex) in day.includes" :key="includeIndex">
              <div class="d-flex align-center">
                <input type="checkbox" :checked="include" @input="updateIncludeByDay(dayIndex, includeIndex)" />
                <span class="caption px-3">Include this day</span>
              </div>
            </v-col>
          </v-row>
          <v-row
            v-for="(cost, costIndex) in day.costs"
            :key="costIndex"
            :class="{
              'grey lighten-4': costIndex % 2 === 0,
              'supplier-setting-day-group__row': true,
            }"
          >
            <v-col align-self="center">
              <div class="mx-3">{{ cost.name }}</div>
            </v-col>
            <v-col align-self="center" v-for="(include, includeIndex) in cost.includes" :key="includeIndex">
              <div class="d-flex align-center mx-3">
                <input
                  type="checkbox"
                  :checked="include"
                  :disabled="isDisabled(dayIndex, includeIndex)"
                  @input="updateIncludeByCost(dayIndex, costIndex, includeIndex)"
                />
                <span class="caption px-3">Include</span>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <v-card-actions>
        <g-button label="Cancel" @onclick="close" />
        <g-button label="Clear" @onclick="clear" />
        <g-button label="Select All" @onclick="selectAll" />
        <div class="flex-grow-1"></div>
        <g-button label="Save" @onclick="save" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    isSubmitting: Boolean,
    value: Boolean,
    data: Object,
  },
  data() {
    return {
      convertedData: null,
    };
  },
  methods: {
    isDisabled(dayIndex, includeIndex) {
      return !this.convertedData.days[dayIndex].includes[includeIndex];
    },
    updateIncludeByDay(dayIndex, includeIndex) {
      const newValue = !this.convertedData.days[dayIndex].includes[includeIndex];
      this.convertedData.days[dayIndex].includes.splice(includeIndex, 1, newValue);
      if (!newValue) {
        this.convertedData.days[dayIndex].costs.forEach((cost) => {
          cost.includes[includeIndex] = false;
        });
      }
    },
    updateIncludeByCost(dayIndex, costIndex, includeIndex) {
      const newValue = !this.convertedData.days[dayIndex].costs[costIndex].includes[includeIndex];
      this.convertedData.days[dayIndex].costs[costIndex].includes.splice(includeIndex, 1, newValue);
    },
    convertData(data) {
      const columns = data.logisticsCosts.map((cost) => ({
        uuid: cost.uuid,
        name: `${cost.supplier?.label ?? ""} / ${cost.product?.label ?? ""}`,
        city: cost.supplierCity,
        isManualCity: cost.supplier.value == null,
      }));
      const days = data.costs.map((cost, index) => {
        const includes = columns.map((column) =>
          data.logisticsCosts.some((logisticsCost) => logisticsCost.uuid === column.uuid && logisticsCost.days?.includes(index))
        );

        const filteredItems = cost.items.filter(
          (item) => ["ROOM", "MEAL", "EXCURSION"].includes(item.productType) && item.costType !== "PG"
        );

        const costs = filteredItems.map((item) => ({
          uuid: item.uuid,
          name: `${item.supplier?.label ?? ""} / ${item.product?.label ?? ""}`,
          includes: columns.map((column) => (item.logisticsCostUUIDs ?? []).includes(column.uuid)),
        }));

        let day = index;
        let header = "Day " + (index + 1);

        const uniqueSupplierCities = new Set();
        filteredItems.forEach((item) => uniqueSupplierCities.add(item.supplierCity));
        header += " : " + Array.from(uniqueSupplierCities).join(" / ");

        return { day: day, header: header, includes, costs };
      });

      this.convertedData = { columns, days };
    },
    close() {
      this.convertData(this.data);
      this.$emit("input", false);
    },
    save() {
      const logisticsCostsMap = {};
      const dayMap = {};
      this.data.logisticsCosts.forEach((cost) => {
        dayMap[cost.uuid] = ["TOUR", "TOUR_LEADER", "TRANS"].includes(cost.productType) ? [] : [0];
      });
      this.convertedData.days.forEach((day) => {
        day.includes.forEach((included, index) => {
          if (included) {
            dayMap[this.convertedData.columns[index].uuid].push(day.day);
          }
        });
        day.costs.forEach((cost) => {
          const costUUID = cost.uuid;
          const logisticsCostUUIDs = cost.includes
            .map((included, index) => (included ? this.convertedData.columns[index].uuid : null))
            .filter((uuid) => uuid !== null);
          logisticsCostsMap[costUUID] = logisticsCostUUIDs;
        });
      });
      this.data.costs.forEach((cost) => {
        cost.items.forEach((item) => {
          item.logisticsCostUUIDs = logisticsCostsMap[item.uuid];
        });
      });
      this.data.logisticsCosts.forEach((cost) => {
        cost.days = dayMap[cost.uuid];
      });

      this.convertData(this.data);
      this.$emit("input", false);
      this.$emit("update", this.data);
    },
    clear() {
      this.convertedData.days.forEach((day) => {
        day.includes = day.includes.map(() => false);
        day.costs.forEach((cost) => {
          cost.includes = cost.includes.map(() => false);
        });
      });
      this.convertedData = JSON.parse(JSON.stringify(this.convertedData));
    },
    selectAll() {
      this.convertedData.days.forEach((day) => {
        day.includes = day.includes.map(() => true);
        day.costs.forEach((cost) => {
          cost.includes = cost.includes.map(() => true);
        });
      });
      this.convertedData = JSON.parse(JSON.stringify(this.convertedData));
    },
    clearByIndex(index) {
      this.convertedData.days.forEach((day) => {
        day.includes[index] = false;
        day.costs.forEach((cost) => {
          cost.includes[index] = false;
        });
      });
      this.convertedData = JSON.parse(JSON.stringify(this.convertedData));
    },
    selectAllByIndex(index) {
      this.convertedData.days.forEach((day) => {
        day.includes[index] = true;
        day.costs.forEach((cost) => {
          cost.includes[index] = true;
        });
      });
      this.convertedData = JSON.parse(JSON.stringify(this.convertedData));
    },
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(newValue) {
        this.convertData(newValue);
      },
    },
  },
};
</script>

<style scoped>
.supplier-setting-day-group {
  margin-top: 16px;
  padding: 8px 10px 10px;
  border: 1px solid #d7dee7;
  border-radius: 8px;
  background: #fbfcfd;
}

.supplier-setting-day-group__header {
  margin-bottom: 4px;
  padding-bottom: 6px;
  border-bottom: 1px solid #e4e9ef;
  background: #f3f7fb;
  border-radius: 6px 6px 0 0;
}

.supplier-setting-day-group__row {
  border-radius: 4px;
}
</style>
